var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04188 33.2C9.47867 37.4095 14.5167 40 20.0624 40C30.3923 40 38.75 31.0476 38.75 20C38.75 8.95238 30.3923 0 20.0624 0C14.5167 0 9.47867 2.59048 6.04188 6.8C5.69039 7.21905 5.5537 7.61905 5.5537 8C5.5537 8.81905 6.31526 9.39048 7.13541 9.39048C7.60406 9.39048 8.09224 9.2 8.44373 8.7619C11.2947 5.21905 15.5126 3.06667 20.0624 3.06667C28.6349 3.06667 35.5866 10.6476 35.5866 20C35.5866 29.3524 28.6349 36.9333 20.0624 36.9333C15.5126 36.9333 11.2947 34.7619 8.44373 31.2381C8.09224 30.8 7.60406 30.6095 7.13541 30.6095C6.31526 30.6095 5.5537 31.181 5.5537 32C5.5537 32.3619 5.69039 32.781 6.04188 33.2Z",
    fill: "#2D3D50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 10.2286V29.7524C0.75 32.1714 2.72225 34.0762 5.06552 34.1905C4.44065 33.4286 4.12821 32.7048 4.12821 32.0381C4.12821 30.4571 5.63181 29.219 7.19399 29.219C8.4242 29.219 9.04908 29.8286 9.86922 30.8C9.94733 30.4571 9.98638 30.1143 9.98638 29.7524V10.2286C9.98638 9.86667 9.94733 9.54286 9.86922 9.2C9.08813 10.1143 8.46326 10.7619 7.21351 10.7619C5.63181 10.7619 4.12821 9.54286 4.12821 7.96191C4.12821 7.29524 4.44065 6.59048 5.06552 5.80952C2.74178 5.92381 0.75 7.80952 0.75 10.2286Z",
    fill: "#2D3D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorOutline);
export default __webpack_public_path__ + "static/media/SensorOutline.c4067ef2af88ca9154489968f38a0738.svg";
export { ForwardRef as ReactComponent };